var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "buyOrderParticulars" },
    [
      _c("van-nav-bar", {
        attrs: {
          title: "买料详情",
          "left-arrow": "",
          fixed: "",
          "safe-area-inset-top": "",
          placeholder: ""
        },
        on: { "click-left": _vm.leftClick }
      }),
      _vm.orderList.status == "SUSPENSE"
        ? _c("div", { staticClass: "reviewProgress  ToBeReviewed" }, [
            _vm._m(0)
          ])
        : _vm._e(),
      _vm.orderList.status == "WAIT_FETCH_AUDIT" ||
      _vm.orderList.status == "WAIT_FETCH" ||
      _vm.orderList.status == "FAIL"
        ? _c("div", { staticClass: "reviewProgress  FailAndReclaiming" }, [
            _vm._m(1)
          ])
        : _vm._e(),
      _vm.orderList.status == "WAIT_FETCH_FINISHED"
        ? _c("div", { staticClass: "reviewProgress reclaiming" }, [_vm._m(2)])
        : _vm._e(),
      _vm.orderList.status == "DONE"
        ? _c("div", { staticClass: "reviewProgress  Completed" }, [_vm._m(3)])
        : _vm._e(),
      _c("div", { staticClass: "orderInfo" }, [
        _c("div", { staticClass: "orderTop title" }, [
          _vm._m(4),
          _c(
            "h3",
            {
              style: {
                color: _vm.orderList.status == "FAIL" ? "red" : "#1a1a1a"
              }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.orderList.status == "WAIT_FETCH_AUDIT"
                    ? "取料审核中..."
                    : _vm.orderList.status == "WAIT_FETCH"
                    ? "待取料"
                    : _vm.orderList.status == "FAIL"
                    ? "未通过"
                    : _vm.orderList.status == "SUSPENSE"
                    ? "待审核"
                    : _vm.orderList.status == "WAIT_FETCH_FINISHED"
                    ? "取料中"
                    : "已完成"
                )
              )
            ]
          )
        ]),
        _c("div", { staticClass: "info" }, [
          _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "leftText" }, [_vm._v("下单时间:")]),
            _c("div", { staticClass: "rightText" }, [
              _vm._v(_vm._s(_vm._f("formatDate_")(_vm.orderList.createTime)))
            ])
          ]),
          _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "leftText" }, [_vm._v("订单编号:")]),
            _c("div", { staticClass: "rightText" }, [
              _vm._v(_vm._s(_vm.orderList.oid))
            ])
          ]),
          _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "leftText" }, [_vm._v("货物分类:")]),
            _c("div", { staticClass: "rightText" }, [
              _vm._v(_vm._s(_vm.orderList.goods[0].name))
            ])
          ]),
          _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "leftText" }, [_vm._v("单价(元/克):")]),
            _c("div", { staticClass: "rightText" }, [
              _vm._v(_vm._s(_vm.orderList.goods[0].price))
            ])
          ]),
          _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "leftText" }, [_vm._v("重量(克):")]),
            _c("div", { staticClass: "rightText" }, [
              _vm._v(_vm._s(_vm.orderList.goods[0].weight.toFixed(2)))
            ])
          ]),
          _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "leftText" }, [_vm._v("金额(元):")]),
            _c("div", { staticClass: "rightText" }, [
              _vm._v(_vm._s(_vm.orderList.goods[0].total))
            ])
          ])
        ])
      ]),
      (_vm.orderList.status == "FAIL" || _vm.orderList.status == "DONE"
      ? false
      : true)
        ? _c("div", { staticClass: "getMoney" }, [
            _c("div", { staticClass: "title" }, [
              _vm._m(5),
              _c(
                "div",
                {
                  staticClass: "copy",
                  on: {
                    click: function($event) {
                      return _vm.copy(_vm.banklist.bankCard.num)
                    }
                  }
                },
                [_vm._v("复制")]
              )
            ]),
            _c("div", { staticClass: "info" }, [
              _c("div", { staticClass: "bankIcon" }, [
                _vm.banklist.id == 10
                  ? _c("img", {
                      staticClass: "Img",
                      attrs: { src: _vm.banklist.bankCard.logo, alt: "" }
                    })
                  : _vm._e(),
                !_vm.banklist.id == 10
                  ? _c("div", { staticClass: "icon" })
                  : _vm._e(),
                _c("div", { staticClass: "bank" }, [
                  _vm._v(_vm._s(_vm.banklist.bankCard.bank))
                ])
              ]),
              _c("div", { staticClass: "moneyflex" }, [
                _c("div", { staticClass: "leftText" }, [_vm._v("银行卡号:")]),
                _c("div", { staticClass: "rightText" }, [
                  _vm._v(_vm._s(_vm.banklist.bankCard.num))
                ])
              ]),
              _c("div", { staticClass: "moneyflex" }, [
                _c("div", { staticClass: "leftText" }, [_vm._v("开户支行:")]),
                _c("div", { staticClass: "rightText" }, [
                  _vm._v(_vm._s(_vm.banklist.bankCard.address))
                ])
              ]),
              _c("div", { staticClass: "moneyflex" }, [
                _c("div", { staticClass: "leftText" }, [_vm._v("持卡人:")]),
                _c("div", { staticClass: "rightText" }, [
                  _vm._v(_vm._s(_vm.banklist.bankCard.name))
                ])
              ])
            ])
          ])
        : _vm._e(),
      _c("div", { staticClass: "settlementSheet" }, [
        _c("h3", { staticClass: "jieSuan" }, [_vm._v("结算单")]),
        _c(
          "div",
          { staticClass: "xiangQing", on: { click: _vm.ToPurchaseSettlement } },
          [
            _c("div", { staticClass: "leftIcon" }),
            _c("div", { staticClass: "rightIcon" })
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "progress" }, [
      _c("div", { staticClass: "icons" }, [
        _c("div", { staticClass: "iconText" }, [
          _c("div", { staticClass: "icon ione" }),
          _c("div", { staticClass: "bottomText" }, [_vm._v("提交订单")])
        ]),
        _c("div", { staticClass: "iconLine ilone" }),
        _c("div", { staticClass: "iconText" }, [
          _c("div", { staticClass: "icon itwo" }),
          _c("div", { staticClass: "bottomText" }, [_vm._v("平台审核")])
        ]),
        _c("div", { staticClass: "iconLine iltwo" }),
        _c("div", { staticClass: "iconText" }, [
          _c("div", { staticClass: "icon ithree" }),
          _c("div", { staticClass: "bottomText" }, [_vm._v("提料")])
        ]),
        _c("div", { staticClass: "iconLine iltwo" }),
        _c("div", { staticClass: "iconText" }, [
          _c("div", { staticClass: "icon ifour" }),
          _c("div", { staticClass: "bottomText" }, [_vm._v("交易完成")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "progress" }, [
      _c("div", { staticClass: "icons" }, [
        _c("div", { staticClass: "iconText" }, [
          _c("div", { staticClass: "icon ione" }),
          _c("div", { staticClass: "bottomText" }, [_vm._v("提交订单")])
        ]),
        _c("div", { staticClass: "iconLine ilone" }),
        _c("div", { staticClass: "iconText" }, [
          _c("div", { staticClass: "icon itwo" }),
          _c("div", { staticClass: "bottomText" }, [_vm._v("平台审核")])
        ]),
        _c("div", { staticClass: "iconLine iltwo" }),
        _c("div", { staticClass: "iconText" }, [
          _c("div", { staticClass: "icon ithree" }),
          _c("div", { staticClass: "bottomText" }, [_vm._v("提料")])
        ]),
        _c("div", { staticClass: "iconLine iltwo" }),
        _c("div", { staticClass: "iconText" }, [
          _c("div", { staticClass: "icon ifour" }),
          _c("div", { staticClass: "bottomText" }, [_vm._v("交易完成")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "progress" }, [
      _c("div", { staticClass: "icons" }, [
        _c("div", { staticClass: "iconText" }, [
          _c("div", { staticClass: "icon ione" }),
          _c("div", { staticClass: "bottomText" }, [_vm._v("提交订单")])
        ]),
        _c("div", { staticClass: "iconLine ilone" }),
        _c("div", { staticClass: "iconText" }, [
          _c("div", { staticClass: "icon itwo" }),
          _c("div", { staticClass: "bottomText" }, [_vm._v("平台审核")])
        ]),
        _c("div", { staticClass: "iconLine iltwo" }),
        _c("div", { staticClass: "iconText" }, [
          _c("div", { staticClass: "icon ithree" }),
          _c("div", { staticClass: "bottomText" }, [_vm._v("提料")])
        ]),
        _c("div", { staticClass: "iconLine iltwo" }),
        _c("div", { staticClass: "iconText" }, [
          _c("div", { staticClass: "icon ifour" }),
          _c("div", { staticClass: "bottomText" }, [_vm._v("交易完成")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "progress" }, [
      _c("div", { staticClass: "icons" }, [
        _c("div", { staticClass: "iconText" }, [
          _c("div", { staticClass: "icon ione" }),
          _c("div", { staticClass: "bottomText" }, [_vm._v("提交订单")])
        ]),
        _c("div", { staticClass: "iconLine ilone" }),
        _c("div", { staticClass: "iconText" }, [
          _c("div", { staticClass: "icon itwo" }),
          _c("div", { staticClass: "bottomText" }, [_vm._v("平台审核")])
        ]),
        _c("div", { staticClass: "iconLine iltwo" }),
        _c("div", { staticClass: "iconText" }, [
          _c("div", { staticClass: "icon ithree" }),
          _c("div", { staticClass: "bottomText" }, [_vm._v("提料")])
        ]),
        _c("div", { staticClass: "iconLine iltwo" }),
        _c("div", { staticClass: "iconText" }, [
          _c("div", { staticClass: "icon ifour" }),
          _c("div", { staticClass: "bottomText" }, [_vm._v("交易完成")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [_c("div", { staticClass: "line" }), _vm._v(" 订单信息")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("div", { staticClass: "line" }),
      _vm._v(" 中鑫金收款账号")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }